'use strict';
module.exports = function (obj) {
	var ret = {};
	var keys = Object.keys(Object(obj));

	for (var i = 0; i < keys.length; i++) {
		ret[keys[i].toLowerCase()] = obj[keys[i]];
	}

	return ret;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/lowercase-keys/index.js
// module id = 56
// module chunks = 0